import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'

interface PropsPostMicrorganismos {
  nome_cientifico: string
  tipo_microrganismo: number
  refetch_microrganismos: Function
}

export const usePostMicrorganismos = (): {
  carregando_salvar_microrganismos: boolean
  mutate_microrganismos: (params: PropsPostMicrorganismos) => void
  isSuccess_microrganismos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostMicrorganismos> = useMutation(
    async (params: PropsPostMicrorganismos) => {
      const { nome_cientifico, tipo_microrganismo, refetch_microrganismos } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`recomendacao/microrganismo?codConta=${localConfig()?.conta}`, {
          nome_cientifico,
          tipo_microrganismo,
        })
        .then((response: any) => {
          successAlert('Microrganismo cadastrado com sucesso!', 5000, 'loading')
          refetch_microrganismos()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar microrganismo!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar microrganismo!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_microrganismos: mutation.isLoading,
    mutate_microrganismos: mutation.mutate,
    isSuccess_microrganismos: mutation.isSuccess,
  }
}

export const usePutMicrorganismos= (
  cod: number
): {
  carregando_edit_microrganismos: boolean
  mutate_edit_microrganismos: (params: PropsPostMicrorganismos) => void
  isSuccess_edit_microrganismos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostMicrorganismos> = useMutation(
    async (params: PropsPostMicrorganismos) => {
      const { nome_cientifico, tipo_microrganismo, refetch_microrganismos } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`recomendacao/microrganismo/${cod}?codConta=${localConfig()?.conta}`, {
          nome_cientifico: nome_cientifico,
          tipo_microrganismo: tipo_microrganismo,
        })
        .then((response: any) => {
          successAlert('Microrganismo atualizado com sucesso!', 5000, 'loading')
          refetch_microrganismos()
          return response
        })
        .catch((error: any) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao editar a microrganismo!', 5000, 'loading')
          throw error
        })
    }
  )

  return {
    carregando_edit_microrganismos: mutation.isLoading,
    mutate_edit_microrganismos: mutation.mutate,
    isSuccess_edit_microrganismos: mutation.isSuccess,
  }
}
